
export default {
  layout: "empty-vuetify",
  auth: "guest",
  data() {
    return {
      valid: true,
      isLoggingIn: false,
      loginErrorMessage: null,
      loginPassword: "",
      loginEmail: "",
      loginEmailRules: [
        (v) => !!v || "Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 8) || "Min 8 characters",
      },
    };
  },
  methods: {
    validate() {
      if (this.$refs.loginForm.validate()) {
        this.isLoggingIn = true;
        this.$auth
          .loginWith("laravelSanctum", {
            data: {
              email: this.loginEmail,
              password: this.loginPassword,
            },
          })
          .then(() => {
            const user = this.$auth.user;
            this.$router.push({
              path: "/",
            });
          })
          .catch((e) => {
            if (e.errors)
              this.loginErrorMessage = Object.values(e.errors)
                .flat()
                .join("; ");
            else this.loginErrorMessage = e.message;
          })
          .finally(() => (this.isLoggingIn = false));
      }
    },
  },
};
